var FOLDERS_QUERY_KEY = 'folders';
var folderKeys = {
  folders: [FOLDERS_QUERY_KEY]
};
export default folderKeys;